import api from '@/api/notification';

let requestIntervalId = null;
const REQUEST_TIMEOUT = 20000;

export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    itemIdsByFilter(state) {
      return filter => state.items.filter(item => !item.isViewed
        && ['companyId', 'projectId', 'taskId', 'stageId', 'commentId', 'agreementId', 'leadId']
          .map(key => !filter[key] || filter[key] === item.info[key])
          .reduce((acc, val) => acc && val, true));
    },
    projectRelatedCount(state) {
      return state.items.filter(item => !item.isViewed && !!item.info.projectId).length;
    },
    companyRelatedCount(state) {
      return state.items.filter(item => !item.isViewed && !!item.info.companyId).length;
    },
    countByProject(state) {
      return state.items
        .filter(item => !item.isViewed && !!item.info.projectId)
        .map(item => item.info.projectId)
        .reduce((acc, val) => ({ ...acc, [val]: (acc[val] ?? 0) + 1 }), {});
    },
    countByStage(state) {
      return state.items
        .filter(item => !item.isViewed && !!item.info.stageId)
        .map(item => item.info.stageId)
        .reduce((acc, val) => ({ ...acc, [val]: (acc[val] ?? 0) + 1 }), {});
    },
    countByTask(state) {
      return state.items
        .filter(item => !item.isViewed && !!item.info.taskId)
        .map(item => item.info.taskId)
        .reduce((acc, val) => ({ ...acc, [val]: (acc[val] ?? 0) + 1 }), {});
    },
    // заявки CRM: напоминания и комментарии по заявке приходят с info.leadId
    countByLead(state) {
      return state.items
        .filter(item => !item.isViewed && !!item.info.leadId)
        .map(item => item.info.leadId)
        .reduce((acc, val) => ({ ...acc, [val]: (acc[val] ?? 0) + 1 }), {});
    },
  },
  mutations: {
    setItems(state, payload) { state.items = payload; },
    hideItem(state, item) {
      const itemOfList = state.items.find((i) => i.id === item.id);
      itemOfList.isHidden = true;
    },
    viewItem(state, item) {
      const itemOfList = state.items.find((i) => i.id === item.id);
      itemOfList.isViewed = true;
    },
    removeItem(state, item) {
      state.items = state.items.filter((i) => i.id !== item.id);
    },
  },
  actions: {
    view({ commit, rootState }, item) {
      if (rootState.auth.user.isImpersonation) return;
      commit('viewItem', item);
      api.update(item.id, { isViewed: true });
    },
    viewForce({ commit }, item) {
      commit('viewItem', item);
      api.update(item.id, { isViewed: true });
    },
    hide({ commit }, item) {
      commit('viewItem', item);
      commit('hideItem', item);
      api.update(item.id, { isViewed: true, isHidden: true });
    },
    delete({ commit }, item) {
      commit('removeItem', item);
      api.delete(item.id);
    },
    fetch({ state, commit, rootState }) {
      if (requestIntervalId) return;

      const fetchList = (isInitialRequest) => {
        api.fetchList().then((r) => {
          const unreadItemsCountBecame = r.items.filter(n => !n.isViewed).length;
          const unreadItemsCountWas = state.items.filter(n => !n.isViewed).length;

          const soundDisabled = rootState.auth.user?.customSettings?.notifications?.soundDisabled;
          if (!isInitialRequest && soundDisabled !== true) {
            if (unreadItemsCountBecame > unreadItemsCountWas) {
              (new Audio('/notification.mp3')).play();
            }
          }

          const favicon = document.getElementById('favicon');
          favicon.href = unreadItemsCountBecame ? '/favicon_active.svg' : '/favicon.svg';

          commit('setItems', r.items);
        });
      };

      fetchList(true);

      requestIntervalId = setInterval(() => {
        if (document.hidden) return;
        fetchList(false);
      }, REQUEST_TIMEOUT);
    },
  },
};
